export { default as Img200 } from './processed/200/Last-Stand-of-the-300-3.jpg';
export { default as Img400 } from './processed/400/Last-Stand-of-the-300-3.jpg';
export { default as Imgthumb } from './processed/thumb/Last-Stand-of-the-300-3.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/Last-Stand-of-the-300-3.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/Last-Stand-of-the-300-3.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      161,
      86,
      73
    ],
    "_population": 30,
    "_hsl": [
      0.02462121212121214,
      0.37606837606837606,
      0.4588235294117647
    ]
  },
  "LightVibrant": {
    "_rgb": [
      215,
      190,
      143
    ],
    "_population": 30,
    "_hsl": [
      0.1087962962962963,
      0.4736842105263159,
      0.7019607843137254
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      93,
      29,
      24
    ],
    "_population": 268,
    "_hsl": [
      0.012077294685990338,
      0.5897435897435898,
      0.22941176470588234
    ]
  },
  "Muted": {
    "_rgb": [
      151,
      137,
      102
    ],
    "_population": 967,
    "_hsl": [
      0.11904761904761901,
      0.1936758893280632,
      0.49607843137254903
    ]
  },
  "LightMuted": {
    "_rgb": [
      207,
      195,
      165
    ],
    "_population": 264,
    "_hsl": [
      0.11904761904761897,
      0.3043478260869565,
      0.7294117647058824
    ]
  },
  "DarkMuted": {
    "_rgb": [
      85,
      74,
      46
    ],
    "_population": 1993,
    "_hsl": [
      0.11965811965811969,
      0.29770992366412213,
      0.2568627450980392
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/Last-Stand-of-the-300-3.js